/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  PamAccountStatusBody,
  PamAccountStatusResponse,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PamAccountStatusBodyFromJSON,
    PamAccountStatusBodyToJSON,
    PamAccountStatusResponseFromJSON,
    PamAccountStatusResponseToJSON,
} from '../models/index';

export interface DeactivatePamPlayerRequest {
    pamPlayerId: string;
    customerId: string;
    pamAccountStatusBody: PamAccountStatusBody;
    xClientID?: string;
    xRequestID?: string;
}

export interface ReactivatePamPlayerRequest {
    pamPlayerId: string;
    customerId: string;
    pamAccountStatusBody: PamAccountStatusBody;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class PAMPlayersApi extends runtime.BaseAPI {

    /**
     * Close a player\'s account on staff instruction: ban their Clerk user and write `deactivated`. Requires a reason. Reversible through the reactivate endpoint.
     */
    async deactivatePamPlayerRaw(requestParameters: DeactivatePamPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PamAccountStatusResponse>> {
        if (requestParameters['pamPlayerId'] == null) {
            throw new runtime.RequiredError(
                'pamPlayerId',
                'Required parameter "pamPlayerId" was null or undefined when calling deactivatePamPlayer().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deactivatePamPlayer().'
            );
        }

        if (requestParameters['pamAccountStatusBody'] == null) {
            throw new runtime.RequiredError(
                'pamAccountStatusBody',
                'Required parameter "pamAccountStatusBody" was null or undefined when calling deactivatePamPlayer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/players/{pamPlayerId}/deactivate`;
        urlPath = urlPath.replace(`{${"pamPlayerId"}}`, encodeURIComponent(String(requestParameters['pamPlayerId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PamAccountStatusBodyToJSON(requestParameters['pamAccountStatusBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PamAccountStatusResponseFromJSON(jsonValue));
    }

    /**
     * Close a player\'s account on staff instruction: ban their Clerk user and write `deactivated`. Requires a reason. Reversible through the reactivate endpoint.
     */
    async deactivatePamPlayer(requestParameters: DeactivatePamPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PamAccountStatusResponse> {
        const response = await this.deactivatePamPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reverse a deactivation: unban the player\'s Clerk user and return them to active. Requires a reason.
     */
    async reactivatePamPlayerRaw(requestParameters: ReactivatePamPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PamAccountStatusResponse>> {
        if (requestParameters['pamPlayerId'] == null) {
            throw new runtime.RequiredError(
                'pamPlayerId',
                'Required parameter "pamPlayerId" was null or undefined when calling reactivatePamPlayer().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling reactivatePamPlayer().'
            );
        }

        if (requestParameters['pamAccountStatusBody'] == null) {
            throw new runtime.RequiredError(
                'pamAccountStatusBody',
                'Required parameter "pamAccountStatusBody" was null or undefined when calling reactivatePamPlayer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/players/{pamPlayerId}/reactivate`;
        urlPath = urlPath.replace(`{${"pamPlayerId"}}`, encodeURIComponent(String(requestParameters['pamPlayerId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PamAccountStatusBodyToJSON(requestParameters['pamAccountStatusBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PamAccountStatusResponseFromJSON(jsonValue));
    }

    /**
     * Reverse a deactivation: unban the player\'s Clerk user and return them to active. Requires a reason.
     */
    async reactivatePamPlayer(requestParameters: ReactivatePamPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PamAccountStatusResponse> {
        const response = await this.reactivatePamPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
